<template>
    <ClientOnly>
        <v-form ref="form" v-model="valid" validate-on="lazy blur">
            <v-card>
                <v-card-text>
                    <v-col>
                        <v-row cols="12">
                            <v-radio-group v-model="donateForm.payType" inline density="compact">
                                <v-radio label="Credit Card" value="信用卡"></v-radio>
                            </v-radio-group>
                            <v-divider></v-divider>
                        </v-row>
                    </v-col>

                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-select label="My donation goes to" hint="*Required" persistent-hint
                                prepend-inner-icon="mdi-bank-outline" v-model="donateForm.purposeId" :items="purpose"
                                item-title="engPurpose" item-value="id" variant="outlined" density="compact"
                                :rules="[requiredEng]"></v-select>
                        </v-row>
                    </v-col>

                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field label="Amount (TWD)" prepend-inner-icon="mdi-piggy-bank-outline"
                                v-model="donateForm.amount" type="number" density="compact"
                                :rules="[requiredEng, v => numberRangeEngRules(v, 100, 500000)]"
                                hint="*Required. The minimum amount for an online donation is 100 TWD." persistent-hint
                                variant="outlined">
                                <template #append-inner>
                                    <v-btn class="mr-1" @click="addAmount(500)" size="small">+500</v-btn>
                                    <v-btn class="mr-1" @click="addAmount(1000)" size="small">+1000</v-btn>
                                </template>

                            </v-text-field>
                        </v-row>
                    </v-col>

                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field label="Name" hint="*Required" persistent-hint
                                prepend-inner-icon="mdi-account-circle" v-model="donateForm.name" density="compact"
                                variant="outlined" :rules="[requiredEng, v => maxLengthEng(v, 150)]"></v-text-field>
                        </v-row>
                    </v-col>
                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field :rules="[emailEngRules]" label="Email"
                                prepend-inner-icon="mdi-email-heart-outline" v-model="donateForm.email"
                                density="compact" variant="outlined" hint="*Required" persistent-hint></v-text-field>
                        </v-row>
                    </v-col>
                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-select label="Year of Graduation" variant="outlined" :items="selectYears"
                                v-model="donateForm.gradYear" :rules="[requiredEng]" density="compact" hint="*Required"
                                persistent-hint></v-select>
                        </v-row>
                    </v-col>
                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field label="Department of Graduation" variant="outlined" density="compact"
                                v-model="donateForm.gradMajor" :rules="[requiredEng]" hint="*Required"
                                persistent-hint></v-text-field>
                        </v-row>
                    </v-col>

                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <div>
                        <v-btn prepend-icon="mdi-cellphone-wireless" height="50" width="150" class="bg-black"
                            @click="submit" variant="outlined">
                            DONATE
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
            <SnackMsg></SnackMsg>                        
        </v-form>
    </ClientOnly>
</template>
<script setup lang="ts">
import { Array } from "effect";
import dayjs from "dayjs";
import type { VForm } from "vuetify/components";
const { requiredEng, numberRangeEngRules, emailEngRules, maxLengthEng } = useFormRules();
const { setMsg } = useMsgState();
const valid = ref(null);
const purpose = ref<DonatPurpose[]>([]);
const selectYears = ref(Array.range(2000, dayjs().year()).reverse());
const donateForm = ref<SampleDonateList>({
    StoreOrderNo: '',
    amount: null,
    name: '',
    id: '',
    email: '',
    contactPhone: '',
    purposeId: null,
    purposeMemo: '',
    address: '',
    payType: '信用卡',
    paperReceipt: 0,
    gradYear: null,
    gradMajor: null,
    temp: "ENGLISH",
    receiptName:'',
    receiptNo:'',
});
const form = ref<VForm>();
let timeId: NodeJS.Timeout | null = null;

const loadPurpose = () => {
    $fetch("/api/purpose").then((res) => {
        purpose.value = [...res.filter(r => !!r.engPurpose == true)];
    });
}


loadPurpose();

const addAmount = (addValue: number) => {
    donateForm.value.amount = (donateForm.value.amount ?? 0) + addValue;
}

const submit = () => {
    form.value!.validate().then((v: any) => {
        if (v.valid) {
            if (timeId == null) {
                timeId = setTimeout(() => {
                    useFetch("/api/newccdonate", { method: "POST", body: donateForm.value })
                        .then((res) => {
                            if (!!res.data.value)
                                navigateTo(`/ccpay/${res.data.value.StoreOrderNo}/${encodeURIComponent(res.data.value.hppUrl)}`);
                            else
                                setMsg(res.error.value?.data.statusMessage);
                        });
                    timeId = null;
                }, 500);
            }
            else {
                clearTimeout(timeId);
                timeId = null;
            }
        }
    })
}

</script>